import React from 'react'

interface LineItemFormProps {
  onSuccess: () => void
}

const LineItemForm: React.FC<LineItemFormProps> = ({ onSuccess }) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // Simulate successful line item creation
    setTimeout(() => {
      console.log('Line Item created successfully')
      onSuccess()
    }, 1000)
  }

  return (
    <div>
      <h2>Line Item Form</h2>
      <form onSubmit={handleSubmit}>
        <div>Line Item form fields go here...</div>
        <button type="submit">Create Line Item</button>
      </form>
    </div>
  )
}

export default LineItemForm
